module.exports = __webpack_public_path__ + "img/file66.feda53eb.png";